import { useState } from 'react';
import { Check, PencilLine } from 'lucide-react';
import PersonalInfo from 'components/Profile/PersonalInfo/Form';
import MedicalHistory from 'components/Profile/MedicalHistory/Form';
import Insurance from 'components/Profile/Insurance/Form';
import Summary from 'components/Profile/View/Summary';
import { FORM_ID, PRIMARY_BTN, SECONDARY_BTN } from './helper';

const SectionStep = ({ stepId, data, completed, practice, onSaved, onClose }) => {
  const [isEditing, setIsEditing] = useState(!completed);
  const [medicalStarted, setMedicalStarted] = useState(false);

  const showSummary = completed && !isEditing;
  const showMedicalIntro = stepId === 'medical' && !completed && !medicalStarted;
  const hideFooter = (stepId === 'insurance' && !showSummary) || showMedicalIntro;

  function handleSaved(saved) {
    onSaved(saved);
    setIsEditing(false);
  }

  const dismiss = () => (isEditing && completed ? setIsEditing(false) : onClose());

  return (
    <>
      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-5 pt-6 sm:px-7">
        {showSummary ? (
          <Summary stepId={stepId} data={data} inModal />
        ) : stepId === 'personal' ? (
          <PersonalInfo personal={data || {}} onSaved={handleSaved} inModal formId={FORM_ID} />
        ) : stepId === 'medical' ? (
          <MedicalHistory medicalHistory={data || {}} onSaved={handleSaved} onCancel={dismiss} onStart={() => setMedicalStarted(true)} inModal formId={FORM_ID} />
        ) : (
          <Insurance insurance={data} practice={practice || {}} onSaved={handleSaved} onCancel={dismiss} inModal />
        )}
      </div>

      {!hideFooter && (
        <div className="grid shrink-0 grid-cols-2 gap-3 border-t border-gray-100 px-6 py-3.5 sm:px-7">
          <button type="button" onClick={dismiss} className={SECONDARY_BTN}>
            {showSummary ? 'Back' : 'Cancel'}
          </button>

          {showSummary ? (
            <button key="update" type="button" onClick={() => setIsEditing(true)} className={PRIMARY_BTN}>
              <PencilLine size={16} />
              Update
            </button>
          ) : (
            <button key="save" type="submit" form={FORM_ID} className={PRIMARY_BTN}>
              <Check size={16} strokeWidth={2.8} />
              Save changes
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default SectionStep;
